import { JwtPayload, jwtDecode } from 'jwt-decode';

import { Region } from '../../../utils';

export const REGION_CLAIM = 'https://confidence.dev/region';

export const ORG_LOGIN_ID_CLAIM = '/org_login_id';
export const IDENTITY_CLAIM = '/identity';

export type ConfidenceJwtPayload = JwtPayload & Record<string, unknown>;

export const getRegionFromTokenOrDefault = (
  token: string,
  defaultRegion: Region = 'EU',
): Region => {
  try {
    const decoded = jwtDecode<ConfidenceJwtPayload>(token);
    return decoded[REGION_CLAIM] === 'US' ? 'US' : defaultRegion;
  } catch (error) {
    return defaultRegion;
  }
};

export const getIdentityFromToken = (token: string): string | undefined => {
  try {
    const decoded = jwtDecode<ConfidenceJwtPayload>(token);
    const identityKey = Object.keys(decoded).find(key =>
      key.endsWith(IDENTITY_CLAIM),
    );
    return identityKey && typeof decoded[identityKey] === 'string'
      ? (decoded[identityKey] as string)
      : undefined;
  } catch (error) {
    return undefined;
  }
};

export const getOrgNameFromToken = (token: string): string | undefined => {
  try {
    const decoded = jwtDecode<ConfidenceJwtPayload>(token);
    const orgKey = Object.keys(decoded).find(key =>
      key.endsWith(ORG_LOGIN_ID_CLAIM),
    );
    return orgKey && typeof decoded[orgKey] === 'string'
      ? (decoded[orgKey] as string)
      : undefined;
  } catch (error) {
    return undefined;
  }
};

export const getExpirationEpochFromToken = (token: string): number | null => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    if (!decoded.exp) {
      return null;
    }

    return decoded.exp * 1000;
  } catch (error) {
    return null;
  }
};
